/**
 * MAX storefront settings API client (BFF: `/api/v1/store/settings/max`).
 *
 * Channel identity/credentials AND transport/messaging behaviour, merged into one resource by
 * WP-BFF.2 of plan-conversation-001 (adr-merchant-portal-015) — the former separate
 * `maxServiceSettingsApi.ts`/`/api/v1/store/settings/max/service` is retired; see `MaxSettings`'s
 * own doc comment in `../model/settingsTypes.ts` for the two-version rationale.
 */
import { apiClient } from '@/shared/api';
import type {
  MaxSettings,
  MaxTestConnectionRequest,
  TestConnectionResult,
  UpdateMaxSettingsRequest,
} from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/max';

export const getMaxSettings = async (): Promise<MaxSettings> => (await apiClient.get<MaxSettings>(BASE)).data;

export const updateMaxSettings = async (body: UpdateMaxSettingsRequest): Promise<MaxSettings> =>
  (await apiClient.put<MaxSettings>(BASE, body)).data;

/**
 * Test the MAX bot connection (gap G3). Pass the operator's currently-typed
 * candidate token to validate it before saving; omit it (empty body) to let
 * the BFF report on the stored credentials instead. The BFF responds with the
 * shared {@link TestConnectionResult} shape (`success`/`message`/`checkedAt`,
 * non-sensitive diagnostics only) — returned as-is so a failed probe renders
 * as a failure, and the screen reuses `TestConnectionButton` with the same
 * visual/UX pattern as the Telegram channel's connection test.
 */
export const testMaxConnection = async (
  body?: MaxTestConnectionRequest,
): Promise<TestConnectionResult> =>
  (await apiClient.post<TestConnectionResult>(`${BASE}/test-connection`, body)).data;
